module.exports = __webpack_public_path__ + "static/media/icon_duplicate-data.240d789e.svg";